<span
    [class]="containerClasses()"
    [ngStyle]="containerStyle()"
    [apInlineSVG]="getAssetUrl()"
    (svgInserted)="onSvgInserted($event)"
    [attr.data-name]="name()"
    data-testid="icon-container"
></span>
